import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "reservation-header" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_fa_icon = _resolveComponent("fa-icon")
  const _component_logo = _resolveComponent("logo")
  const _component_v_col = _resolveComponent("v-col")
  const _component_v_row = _resolveComponent("v-row")
  const _component_v_sheet = _resolveComponent("v-sheet")

  return (_openBlock(), _createBlock(_component_v_sheet, { class: "px-4 rounded-lg elevation-1 my-6" }, {
    default: _withCtx(() => [
      _createElementVNode("header", _hoisted_1, [
        _createVNode(_component_v_row, { class: "header-wrapper align-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              class: "d-flex justify-center align-center position-relative"
            }, {
              default: _withCtx(() => [
                (!$options.isConfirmationPage)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "action position-absolute left-0 pl-5",
                      onClick: _cache[0] || (_cache[0] = (...args) => ($options.goBack && $options.goBack(...args)))
                    }, [
                      ($options.showBackButton)
                        ? (_openBlock(), _createBlock(_component_fa_icon, {
                            key: 0,
                            icon: ['far', 'angle-left']
                          }))
                        : (!$data.prevRoute)
                          ? (_openBlock(), _createBlock(_component_fa_icon, {
                              key: 1,
                              icon: ['far', 'xmark']
                            }))
                          : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_logo, {
                  class: "reservation-header-logo",
                  onClick: $options.handleClickLogo
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}